import { createPinia, PiniaPluginContext } from 'pinia'
import { piniaCapacitorPersist } from 'pinia-plugin-capacitor-persist'

const Boot = async ({ app }) => {
  const pinia = createPinia()

  pinia.use((context: PiniaPluginContext) => {
    piniaCapacitorPersist(context).catch(console.error)
    return {}
  })

  app.use(pinia)
}

export default Boot
